import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Button } from 'react-bootstrap';

// COMPONENTS
import { ModalAddressBookV3, ModalVoucherCode } from '../../Modals';

// ASSETS
import PinAddress from '../../../images/pin-address.png';
import BackArrow from '../../../images/shopping-cart-back.png';
import ContinueArrow from '../../../images/shopping-cart-continue.png';

// Actions
import { convertToRupiah, formatCurrency, formatCurrencyV2 } from '../../../utils';

const PinAddressIcon: any = PinAddress;
const BackArrowIcon: any = BackArrow;
const ContinueArrowIcon: any = ContinueArrow;

interface selectedAddress {
  alias: string;
  full_name: string;
  street_address: string;
  city: string;
  province: string;
  postal_code: string;
  id: number;
}

interface shippingHistory {
  data: Array<Object>;
}

interface countries {
  data: Array<Object>;
}

interface cities {
  data: Array<Object>;
}

interface provinces {
  data: Array<Object>;
}

interface dataVoucher {
  data: [];
}

interface selectedVoucherCode {
  code: number;
}

interface sell {
  subsidy_price: string;
}

type RightBagSectionSummaryProps = {
  selectedAddress: selectedAddress;
  shippingHistory: shippingHistory;
  isAddressBookOpen: boolean;
  countries: countries;
  cities: cities;
  provinces: provinces;
  shippingId: number;
  defaultId: number;
  isAddressButtonDisable: boolean;
  dataVoucher: dataVoucher;
  selectedVoucherCode: selectedVoucherCode;
  openVoucherModal: boolean;
  _discount: string;
  asking_price: string;
  _sell: sell;
  _shippingFee: string;
  totalAddOnProduct: string;
  total: number;
  isCashback: boolean;
  isFetchCourier: boolean;
  voucher_applicable: boolean;
  errMessages: Array<string>;
  changeId: () => void;
  _getTotal: () => void;
  _getLayananPrice: () => number | void;
  submitShipping: () => void;
  getHistoryShipping: () => void;
  handleClearVoucher: () => void;
  setOpenVoucherModal: (openVoucherModal: boolean) => void;
  _handleSelectedAddress: () => void;
  handleModalAddressToggle: () => void;
  handleSelectedVoucherCode: () => void;
  backToDetailsPage: () => void;
  setAmountToBePaid: (total: number) => void;
  setCheckoutProcess: (arg: string) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  handleFetchKredivoInstallments: (args?: number) => void;
  handleSetAtomePrice: (args?: number) => void;
};

const RightBagSectionSummary: React.FC<RightBagSectionSummaryProps> = ({
  selectedAddress,
  isAddressBookOpen,
  shippingHistory,
  countries,
  cities,
  provinces,
  shippingId,
  defaultId,
  isAddressButtonDisable,
  dataVoucher,
  selectedVoucherCode,
  openVoucherModal,
  _discount,
  asking_price,
  _sell,
  _shippingFee,
  totalAddOnProduct,
  errMessages,
  total,
  isCashback,
  isFetchCourier,
  voucher_applicable,
  changeId,
  _getTotal,
  submitShipping,
  _getLayananPrice,
  backToDetailsPage,
  getHistoryShipping,
  setOpenVoucherModal,
  handleClearVoucher,
  _handleSelectedAddress,
  handleModalAddressToggle,
  handleSelectedVoucherCode,
  setIsErrorModalOpen,
  setCheckoutProcess,
  setAmountToBePaid,
  handleFetchKredivoInstallments,
  handleSetAtomePrice,
  userCurrency,
}): JSX.Element => {
  const [defaultAddressTemp, setDefaultTempAddress] = useState(null)
  return (
    <Col className="right-bag-content">
      <Row
        className="right-bag-content-section-wrapper right-bag-address-section"
        onClick={() => handleModalAddressToggle()}
      >
        <Col className="shopping-cart-address-section-image-container">
          <KickImage src={PinAddress} alt="..." />
        </Col>
        <Col className="shopping-cart-address-section-description-container">
          <p>Deliver to</p>
          {selectedAddress?.isAddressNotNull ? (
            <>
              <p>
                {selectedAddress.alias} - {selectedAddress.full_name}
              </p>
              <p>
                {selectedAddress.street_address}, {selectedAddress.city},{' '}
                {selectedAddress.province}, {selectedAddress.postal_code}
              </p>
            </>
          ) : (
            <>
              <p>
                You haven't add any address yet.
              </p>
              <p>
                Add your shipping address to continue.
              </p>
            </>
          )}
        </Col>
        {isAddressBookOpen && (
          <ModalAddressBookV3
            isOpen={isAddressBookOpen}
            onToggle={() => handleModalAddressToggle()}
            dataAddress={shippingHistory.data || []}
            countries={countries.data || []}
            provinces={provinces.data || []}
            cities={cities.data || []}
            id={shippingId ? shippingId : selectedAddress.id}
            changeId={changeId}
            defaultId={defaultId}
            submitShipping={submitShipping}
            getHistoryShipping={getHistoryShipping}
            handleSelectedAddress={_handleSelectedAddress}
            isModalOffer={true}
            isAddressButtonDisable={isAddressButtonDisable}
            setDefaultTempAddress={setDefaultTempAddress}
            defaultAddressTemp={defaultAddressTemp}
          />
        )}
      </Row>
      <Row className="right-bag-content-section-wrapper right-bag-voucher-section">
        <Row className="right-bag-voucher-section-title">
          <p>Have a voucher code?</p>
        </Row>
        <Row className={`right-bag-voucher-section-content ${voucher_applicable ? "" : "right-bag-voucher-section-content-disabled"}`}>
          {
            voucher_applicable ?
              <>
                <Col className={`right-bag-voucher-text`}>
                  <p>
                    {selectedVoucherCode
                      ? `${selectedVoucherCode.code}`
                      : dataVoucher.data.length > 0
                        ? 'You have vouchers available'
                        : 'Enter voucher code here'}
                  </p>
                </Col>
                <Button
                  className="right-bag-voucher"
                  onClick={() => setOpenVoucherModal(!openVoucherModal)}
                >
                  <p>View</p>
                </Button>
              </>
              :
              <div className="right-bag-voucher-text">
                <p>Cannot use voucher on this product</p>
              </div>
          }
        </Row>
        <ModalVoucherCode
          isOpen={openVoucherModal}
          onToggle={() => setOpenVoucherModal(!openVoucherModal)}
          selectedVoucherCode={selectedVoucherCode}
          handleSelectedVoucherCode={handleSelectedVoucherCode}
          _handleClearVoucher={handleClearVoucher}
          discount={_discount}
        />
      </Row>
      <Row className="right-bag-content-section-wrapper right-bag-summary-wrapper">
        <Row className="summary-title right-bag-content-summary-row">
          <p>Payment Summary</p>
        </Row>
        <Row className="right-bag-content-summary-row">
          <p>Product Price</p>
          <p>
            <span>{userCurrency.currency || 'IDR'}</span>
            {formatCurrencyV2(
              parseInt(asking_price),
              userCurrency.ratio,
              userCurrency.currency,
            )}
          </p>
        </Row>
        {_getLayananPrice() > 0 && (
          <Row className="layanan-price right-bag-content-summary-row">
            <p>Administration Fee</p>
            <p>
              <span>{userCurrency.currency || 'IDR'}</span>
              {formatCurrencyV2(
                _getLayananPrice(),
                userCurrency.ratio,
                userCurrency.currency,
              )}
            </p>
          </Row>
        )}
        {parseInt(_shippingFee) > 0 && (
          <Row className="shipping-fee right-bag-content-summary-row">
            <p>Shipping &#38; Handling</p>
            <p>
              <span>{userCurrency.currency || 'IDR'}</span>

              {formatCurrencyV2(
                _shippingFee,
                userCurrency.ratio,
                userCurrency.currency,
              )}
            </p>
          </Row>
        )}
        {selectedVoucherCode && parseInt(_discount) > 0 && (
          <Row className="discount right-bag-content-summary-row">
            <p>{isCashback ? "Potential Cashback" : "Voucher Code"}</p>
            <p className={`${isCashback ? "cashback" : ""}`}>
              <span>{_discount ? isCashback ? "" : '-' : ""}{' '} {userCurrency.currency}</span>
              {formatCurrencyV2(
                _discount,
                userCurrency.ratio,
                userCurrency.currency,
              )}
            </p>
          </Row>
        )}
        {parseInt(_sell.subsidy_price) > 0 && (
          <Row className="subsidy-price right-bag-content-summary-row">
            <p>
              Discount &#40;<span>Automatically applied</span>&#41;
            </p>
            <p>
              <span>{userCurrency.currency || 'IDR'}</span>

              {formatCurrencyV2(
                _sell.subsidy_price,
                userCurrency.ratio,
                userCurrency.currency,
              )}
            </p>
          </Row>
        )}
        {parseInt(totalAddOnProduct) > 0 && (
          <Row className="total-addon-price right-bag-content-summary-row">
            <p>Promo Product</p>
            <p>
              <span>{userCurrency.currency || 'IDR'}</span>

              {formatCurrencyV2(
                totalAddOnProduct,
                userCurrency.ratio,
                userCurrency.currency,
              )}
            </p>
          </Row>
        )}
        <Row className="total-price right-bag-content-summary-row">
          <p>Total</p>
          <p>
            <span>{userCurrency.currency || 'IDR'}</span>

            {formatCurrencyV2(total, userCurrency.ratio, userCurrency.currency)}
          </p>
        </Row>
        <Row className="right-bag-content-summary-button">
          <Button onClick={() => backToDetailsPage()}>
            <KickImage src={BackArrowIcon} alt="..." />
            <p>Back</p>
          </Button>
          <Button
            onClick={() => {
              if (errMessages.length > 0) {
                setIsErrorModalOpen(true);
              } else {
                setCheckoutProcess('choose-payment');
                setAmountToBePaid(total);
              }
              handleFetchKredivoInstallments();
              handleSetAtomePrice();
            }}
            className={isFetchCourier ? "disabled" : ""}
          >
            <p>Choose Payment</p>
            <KickImage src={ContinueArrowIcon} alt="..." />
          </Button>
        </Row>
      </Row>
    </Col>
  );
};

export default RightBagSectionSummary;
